module.exports = __webpack_public_path__ + "static/img/CISM.3ada98c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/expert/CISM.jpg
// module id = wuIm
// module chunks = 0